export default {
  'auth:common:label-email': 'E-Mail',
  'auth:common:label-email:focus': 'Your email address',
  'auth:common:label-password': 'Password',
  'auth:common:label-new-password': 'New password',
  'auth:common:label-repeat-new-password': 'Repeat new password',
  'auth:common:button:to-login': 'To Login',

  'auth:activate-account:header': 'Activate account',
  'auth:activate-account:sub-header': 'Please set a password for your account',
  'auth:activate-account:account-activated': 'Your account has been activated.',
  'auth:activate-account:button:activate': 'Activate account',
  'auth:activate-account:error-message':
    'An error occurred. Please try again later!',

  'auth:login:header': 'Login',
  'auth:login:sheet:header': 'Welcome to Pets Deli',
  'auth:login:label:password': 'Password',
  'auth:login:button:login': 'Login',
  'auth:login:button:recover-password': 'Forgot password?',

  'auth:recover-password:header': 'Forgot password',
  'auth:recover-password:sub-header':
    'We have sent you an email with a link to reset your password!',
  'auth:recover-password:button:reset-confirm': 'Reset password',
  'auth:recover-password:button:back-to-login': ' Back to Login',

  'auth:reset-password:header': 'Set new password',
  'auth:reset-password:button:change': 'Change password',
  'auth:reset-password:confirm': 'Your password has been changed successfully.',
  'auth:reset-password:button:continue-purchase': 'Continue shopping',

  // Login Warning Messages
  'auth:login-warning:title:ch-shop':
    'Oh no! 🐾 Your account belongs to the German shop.',
  'auth:login-warning:title:de-shop':
    'Oh no! 🐾 Your account belongs to the Swiss shop.',
  'auth:login-warning:message:ch-shop':
    'Please note: Your German customer account cannot be used in the Swiss shop.',
  'auth:login-warning:message:de-shop':
    'Please note: Your Swiss customer account cannot be used in the German shop.',
  'auth:login-warning:link:ch-shop': '👉 Go to the German Shop',
  'auth:login-warning:link:de-shop': '👉 Go to the Swiss Shop',
  'auth:login-warning:footer':
    'Thank you for your understanding and see you soon in the right shop! 💚',
};